<template>
  <div class="MemberStudy">
    <SubjectSelector class="sub-wrap" @subject-change="handleSubjectChange" />
    <el-tabs class="courseTab" v-model="activeName">
      <el-tab-pane label="系统课" name="0">
        <TabPaneContent :type="0" ref="courseTab-0" :subject="subject" />
      </el-tab-pane>
      <el-tab-pane v-if="isCzScenes && hasInteractiveCourse" label="互动课" name="1" lazy>
        <TabPaneContent :type="0" isInteractive ref="courseTab-1" :subject="subject" />
      </el-tab-pane>
      <el-tab-pane label="赠课" name="2" lazy>
        <TabPaneContent :type="1" ref="courseTab-2" :subject="subject" />
      </el-tab-pane>
      <el-tab-pane label="资料课" name="3" lazy>
        <!-- 激活时初始化以保证 学习状态（已学、上次学到）及时更新 -->
        <TabPaneContent v-if="activeName === '3'" :type="2" ref="courseTab-3" :subject="subject" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { triggerLoaded } from '@/components/LoadContainer.vue';
import TabPaneContent from './TabPaneContent.vue';
import SubjectSelector from '@/components/SubjectSelector';
import { nextTick } from 'vue';
const COURSE_TYPE = [0, 11, 1, 2];
export default {
  name: 'MemberStudy',
  components: {
    TabPaneContent,
    SubjectSelector,
  },

  data() {
    return {
      activeName: '0',
      isCzScenes: location.hostname.includes('czmstt'),
      // isCzScenes: true,
      hasInteractiveCourse: false,
      homeworkPopupLock: false,
      subject: 0,
    };
  },
  watch: {
    activeName: {
      immediate: true,
      handler(newVal) {
        if (!this.isFirstLoad) {
          this.isFirstLoad = true;
        } else {
          nextTick(() => {
            const currentRef = this.$refs[`courseTab-${newVal}`];
            if (currentRef && currentRef.lastSubject !== this.subject) {
              currentRef.getInitialData(true);
            }
          });
        }
        this.$webSeeSendTrack({
          event_id: 'my_study_tab_click',
          event_type: 'click',
          data: {
            course_type: COURSE_TYPE[newVal],
          },
        });
      },
    },
  },
  async created() {
    triggerLoaded(this);
    if (this.$route.query.bookCourse) {
      this.activeName = '1';
    }
  },
  async mounted() {
    setTimeout(() => {
      this.$webSeeSendTrack({
        event_id: 'my_courses_page_show',
      });
    }, 500);
    this.visibilityChangeHandler = () => {
      // 当页面变为可见时
      if (document.visibilityState === 'visible') {
        this.checkUnfinishedHomework();
      }
    };
    this.checkUnfinishedHomework();
    document.addEventListener('visibilitychange', this.visibilityChangeHandler);
    if (this.isCzScenes) {
      const data = await this.$http.get('/api/app/myStudy/v2/1', {
        biz_type: 11,
        course_gift_type: 0,
      });
      if (data.courseList.length > 0) {
        this.hasInteractiveCourse = true;
      }
      //  0, //系统课
      //  1, //免费课
      //  2, //资料课
      //  11,// 互动课
      this.$webSeeSendTrack({
        event_id: 'my_study_tab_page_show',
        data: {
          course_types: [0, 1, 2, 11],
        },
      });
      if (this.$route.query.id) {
        this.activeName = '1';
      }
    } else {
      this.$webSeeSendTrack({
        event_id: 'my_study_tab_page_show',
        data: {
          course_types: [0, 1, 2],
        },
      });
    }
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
  },
  methods: {
    handleSubjectChange(subject) {
      this.$webSeeSendTrack({
        event_id: 'my_study_subject_filter',
        event_type: 'click',
        data: {
          subjectValue: subject.value,
          subjectKey: subject.key,
        },
      });
      this.subject = subject.key;
      nextTick(() => {
        // 根据选中的学科进行相应的操作
        const currentRef = this.$refs[`courseTab-${this.activeName}`];
        if (currentRef) {
          // currentRef.initSelectedCourseIndex = 0;
          currentRef.getInitialData(true);
        }
      });
    },
    async checkUnfinishedHomework() {
      if (this.homeworkPopupLock) return;
      this.homeworkPopupLock = true;
      setTimeout(() => {
        this.homeworkPopupLock = false;
      }, 1000); // 1秒内只弹一次

      const id = sessionStorage.getItem('period_id');
      const sub_type = sessionStorage.getItem('sub_type');
      if (!id || !sub_type) {
        return;
      }
      const storageKey = `HOMEWORK_COMPLETED_${id}_${sub_type}`;
      const hasEmitted = localStorage.getItem(storageKey);
      if (hasEmitted) {
        return; // 已经提示过了
      }
      try {
        const dialogResult = await this.$http.get('/backend-api/app/homework/popup', {
          period_id: id,
          scene: sub_type === 'zhibo' ? 'live' : 'playback',
          source: 'pc',
        });
        if (dialogResult.display) {
          localStorage.setItem(storageKey, 'true'); // 标记为已提示
          const result = await this.$confirm(dialogResult.content, dialogResult.title, {
            type: '',
            confirmButtonText: dialogResult.buttonMsg,
            cancelButtonText: '返回',
            showIcon: false,
          });
          this.$webSeeSendTrack({
            event_id: 'study_info_homework_dialog_show',
            event_type: 'show',
          });
          if (result) {
            this.$router.push({
              path: '/homework/intro',
              query: {
                hw_id: dialogResult.hwId,
                id: dialogResult.reportId || '0',
              },
            });
            this.$webSeeSendTrack({
              event_id: 'study_task_homework_dialog_Confirm',
              event_type: 'click',
            });
          } else {
            this.$webSeeSendTrack({
              event_id: 'study_task_homework_dialog_close',
              event_type: 'click',
            });
          }
        }
      } catch (error) {
        console.error('检查未完成作业失败:', error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.MemberStudy {
  position: relative;
  .sub-wrap {
    position: absolute;
    right: 32px;
    z-index: 100;
    top: 18px;
  }
  .courseTab {
    ::v-deep {
      .el-tabs__header {
        padding: 13px 32px 13px 8px;
        border-radius: 8px;
        background: #fff;
        margin-bottom: 8px;
        .el-tabs__nav-wrap {
          &::after {
            display: none;
          }

          .el-tabs__active-bar {
            display: none;
            border-radius: 20px;
            background: #f55;
          }

          .el-tabs__item {
            position: relative;
            height: 30px;
            margin: 0 16px;
            padding: 0 8px;
            line-height: 30px;
            color: #706e79;
            font-size: 16px;

            &.is-active {
              color: #000 !important;
              font-weight: 500;

              &::after {
                content: '';
                position: absolute;
                display: inline-block;
                bottom: 0;
                height: 2px;
                width: 24px !important;
                border-radius: 20px;
                background: #f55;
                left: 50% !important;
                transform: translateX(-50%) !important;
              }
            }
          }
        }
      }
    }
  }
}
</style>
